import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ItemService } from '../item.service';
import { FormArray, FormGroup } from '@angular/forms';

@Component({
  selector: 'cc-item-pages',
  templateUrl: './item-pages.component.html',
  styleUrls: ['./item-pages.component.scss']
})
export class ItemPagesComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;

  constructor(private itemService: ItemService) {}

  ngOnInit() {
    this.itemService.addField(this.form, {
      pages: [{ page: '' }]
    });
  }

  get pagesForm(): FormArray {
    return this.form.get('pages') as FormArray;
  }

  get showRemovalIcon() {
    return this.pagesForm.length > 1;
  }

  ngOnDestroy(): void {
    this.form.removeControl('pages');
  }

  addPage() {
    this.pagesForm.push(this.itemService.createGroupItem({ page: '' }));
  }

  removePage(index) {
    this.pagesForm.removeAt(index);
  }
}
